import styled from 'styled-components/macro';

export const Section = styled('div')<any>`
  display: flex;
  margin: 0 10%;

  @media screen and (max-width: 1380px) {
    margin: 0 5%;
  }
  @media screen and (max-width: 500px) {
    margin: 0 23px;
  }
`;

export const TextBlock = styled('div')`
  display: flex;
  flex-direction: column;
  color: #ffffff;
`;

export const StepsBlock = styled('div')`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  color: #ffffff;
  gap: 80px;
`;

export const StepOne = styled('div')`
  display: flex;
  width: 15rem;
  flex-direction: column;
  color: #ffffff;
`;

export const StepTwo = styled('div')`
  display: flex;
  width: 20rem;
  flex-direction: column;
  color: #ffffff;
`;

export const GridContainer = styled('div')<any>`
  display: grid;
  ${({ isMobileScreen }): string =>
    isMobileScreen
      ? 'grid-template-columns: 350px;'
      : 'grid-template-columns: 350px 270px;'};
  gap: 10px;
`;

export const GridItem = styled('div')`
  font-family: 'Proxima Nova';
  font-size: 14px;
  color: #000000;
`;

export const ImgContainer = styled('div')`
  display: flex;
  justify-content: center;
`;

export const Bold = styled('span')`
  font-weight: bold;
`;

export const Wrapper = styled('div')<any>`
  display: flex;
  flex-direction: column;
  min-height: 620px;
  background: linear-gradient(90deg, #20a8cc, #1fc083);
  ${({ isMobileScreen }): string =>
    !isMobileScreen
      ? 'justify-content: space-between;'
      : 'padding-bottom: 3rem;'}

  @media screen and (max-width: 1200px) {
    min-height: 600px;
  }
`;

export const IconWrapper = styled('div')`
  display: flex;
  margin-top: -24px;

  @media screen and (max-width: 1200px) {
    margin-top: -32px;
    svg {
      width: 410px;
    }
  }
  @media screen and (max-width: 1000px) {
    svg {
      width: 400px;
    }
  }
`;

export const MainText = styled('h1')`
  font-size: 64px;
  font-weight: 600;
  line-height: 78px;
  margin: 0;

  @media screen and (max-width: 1200px) {
    font-size: 54px;
    line-height: 64px;
  }
  @media screen and (max-width: 1100px) {
    font-size: 50px;
    line-height: 60px;
  }
  @media screen and (max-width: 1000px) {
    font-size: 44px;
    line-height: 54px;
  }
  @media screen and (max-width: 850px) {
    font-size: 38px;
    line-height: 44px;
  }
`;

export const SubText = styled('h2')`
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  margin: 0;

  @media screen and (max-width: 1000px) {
    font-size: 20px;
    line-height: 28px;
  }
  @media screen and (max-width: 850px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const QRCodeWrapper = styled('div')`
  padding: 20px;
  background: #ffffff;
  width: 160px;
  height: 160px;
  margin: 26px 0 22px 0;
`;

export const InstallationInstructionsButton = styled('button')`
  margin-top: 26px;
  padding: 0.8rem 1.1rem;
  width: 12rem;
  border-color: ${({ theme }): string => theme.AccentGreen};
  border-style: solid;
  border-width: 1px;
  background-color: ${({ theme }): string => theme.White};
  color: ${({ theme }): string => theme.AccentGreen};
  font-size: 0.85rem;
  font-weight: 400;
  cursor: pointer;
`;

export const CloseButton = styled('button')`
  margin-top: 26px;
  margin-bottom: 20px;
  padding: 0.8rem 1.1rem;
  width: 13rem;
  border-color: ${({ theme }): string => theme.AccentGreen};
  border-style: solid;
  border-width: 1px;
  background-color: ${({ theme }): string => theme.White};
  color: ${({ theme }): string => theme.AccentGreen};
  font-size: 0.85rem;
  font-weight: 400;
  cursor: pointer;
`;

export const CloseButtonContainer = styled('div')`
  display: flex;
  justify-content: center;
`;

export const StyledLink = styled('a')`
  color: #000000;
  text-decoration: underline;
  font-weight: bold;
`;
